import { Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { SessionService } from "./session.service";
import Funcionalidades from "@shared/enums/funcionalidades.enum";
import { BehaviorSubject, filter } from "rxjs";
import AccionesFuncionalidad from "@shared/enums/acciones.enum";

interface Breadcrumb {
	label: string;
	url: string;
}

@Injectable({
    providedIn: "root",
})
export class BreadCrumbService {
    constructor(private router: Router, private route: ActivatedRoute, private sessionService: SessionService) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                delete this.idFuncionalidad;
                const crumbs = this.buildBreadCrumb(this.route.root, '', [...this.BreadCrumbs]);
                this.breadcrumbsSubject.next(crumbs);
            });
    }

    private BreadCrumbs: Breadcrumb[] = [
        { label: 'Home', url: '/inicio' },
        { label: 'Fiscalización', url: '/inicio' }
    ];

    private idFuncionalidad: Funcionalidades;

    private breadcrumbsSubject = new BehaviorSubject<Breadcrumb[]>([]);
    breadcrumbs$ = this.breadcrumbsSubject.asObservable();

    private buildBreadCrumb(
            route: ActivatedRoute,
            url: string = "",
            breadcrumbs: Breadcrumb[] = []
        ): Breadcrumb[] {
            const children: ActivatedRoute[] = route.children;
            if (children.length === 0) {
                return [...breadcrumbs];
            }
            let accionId: AccionesFuncionalidad;
    
            for (const child of children) {
                if (child.snapshot.data.hasOwnProperty("breadcrumb") && !child.snapshot.data["breadcrumb"]) return this.buildBreadCrumb(child, url, [...breadcrumbs]);
                const routeURL: string = child.snapshot.url
                    .map((segment) => segment.path)
                    .join("/");
                if (routeURL !== "") {
                    url += `/${routeURL}`;
                }
                if (!this.idFuncionalidad && child.snapshot.data["funcionalidad"]) {
                    this.idFuncionalidad = child.snapshot.data["funcionalidad"]
                    const label = this.sessionService.getFunctionality(this.idFuncionalidad).nombre_fnc;
                    if (!breadcrumbs.some(b => b.label === label))
                        breadcrumbs.push({ label: label, url });
                }
                if (child.snapshot.data["accion"]) {
                    accionId = child.snapshot.data["accion"]
                    const label = this.sessionService.getAction(this.idFuncionalidad, accionId).nombre_acc;
                    if (!breadcrumbs.some(b => b.label === label))
                    breadcrumbs.push({ label: label, url });
                }
    
                return this.buildBreadCrumb(child, url, [...breadcrumbs]);
            }
    
            return [...breadcrumbs];
        }
}